<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.invoicing') }}</h5>
    </template>

    <b-row>
      <b-col md="6">
        <o-form-group :label="$t('sandoz.payment_schema')">
          <b-form-select v-model="item.payment_schema" :options="paymentSchemas" :disabled="readonly"/>
        </o-form-group>
      </b-col>
      <b-col md="6">
        <h6>{{ $t('sandoz.quick_invoice') }}</h6>
        <div class="btn-group btn-group-sm flex-wrap">
          <b-btn v-for="preset in quickPresets" :key="preset.label"
                 variant="outline-primary"
                 :disabled="readonly"
                 @click="openInvoiceForRange(preset)">
            {{ preset.label }}
          </b-btn>
        </div>
      </b-col>
    </b-row>

    <hr/>

    <h6>{{ $t('sandoz.invoices') }}</h6>
    <p v-if="!invoices.length" class="text-muted">{{ $t('sandoz.no_invoices_yet') }}</p>
    <table v-else class="table table-sm">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ $t('sandoz.created_at') }}</th>
          <th>{{ $t('sandoz.period') }}</th>
          <th>{{ $t('sandoz.payment_due') }}</th>
          <th>{{ $t('sandoz.payment_executed') }}</th>
          <th>{{ $t('sandoz.amount') }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="invoice in invoices" :key="invoice.id">
          <td>#{{ invoice.id }}</td>
          <td>{{ invoice.created_at }}</td>
          <td>{{ invoicePeriod(invoice) }}</td>
          <td>{{ invoice.payment_due }}</td>
          <td>{{ invoice.payment_executed }}</td>
          <td class="text-right">{{ invoice.amount }}</td>
          <td>
            <b-btn size="sm" variant="link" @click="downloadInvoice(invoice)">
              <fa icon="download"/>
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-muted small mt-3">{{ $t('sandoz.invoicing_phase4_note') }}</p>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Payment schema, invoice list, invoice generation buttons.
 *
 * Source: ContractBaseController invoice payload + ContractInvoiceController endpoints.
 * The full per-line invoice configuration UI from the legacy pages stays out of this first
 * cut — the quick-preset buttons open a window onto the existing invoice render endpoint, and
 * the invoice list is read-only with a download link.
 */
export default {
  name: 'SectionInvoicing',
  mixins: [sectionMixin],
  data() {
    return {
      paymentSchemas: [
        { value: null, text: '-' },
        { value: 'monthly', text: 'monthly' },
        { value: 'quarterly', text: 'quarterly' },
        { value: 'semester', text: 'semester' },
        { value: 'yearly', text: 'yearly' },
        { value: 'on_delivery', text: 'on_delivery' }
      ],
      quickPresets: [
        { label: 'Q1', start: 1, end: 3 },
        { label: 'Q2', start: 4, end: 6 },
        { label: 'Q3', start: 7, end: 9 },
        { label: 'Q4', start: 10, end: 12 },
        { label: 'S1', start: 1, end: 6 },
        { label: 'S2', start: 7, end: 12 },
        { label: 'Year', start: 1, end: 12 }
      ]
    }
  },
  computed: {
    invoices() {
      return Array.isArray(this.item.invoices) ? this.item.invoices : []
    }
  },
  methods: {
    invoicePeriod(invoice) {
      if (invoice.start_month && invoice.end_month) {
        return `${invoice.start_month}–${invoice.end_month}`
      }
      return '-'
    },
    openInvoiceForRange(preset) {
      const url = `/api/sandoz/contracts/${this.item.id}/invoice/${preset.start}/${preset.end}`
      window.open(url, '_blank')
    },
    downloadInvoice(invoice) {
      const url = `/api/sandoz/contract_invoice_pdfs/download`
      // Existing endpoint expects a POST; for the scaffold we just navigate.
      window.open(`${url}?id=${invoice.id}`, '_blank')
    }
  }
}
</script>
